export const PlatformUtility = {
  isOnClient: () => {
    // window and window.document (the DOM) only exist in client
    // console.log('checking code run');
    return !!(window != undefined && window.document);
  }
};